/**
 * PDPA lawful-basis record (COMPLIANCE Constraint 4). Consent is per channel and
 * revocable, so it is stored as a decision per channel rather than one blanket
 * flag — "they agreed to the terms" is not a lawful basis for sending a land
 * deed over WhatsApp.
 */
export const CONSENT_CHANNELS = ["in_app", "email", "whatsapp"];
/**
 * THE CHANNELS THIS PLATFORM CAN ACTUALLY SEND ON. Empty means it sends nothing.
 * ===========================================================================
 *
 * This exists because of a whole class of bug no guard in this repo could catch.
 *
 * Every copy guard here bans AFFIRMATIVE over-claims — "we will email you", "your
 * title is clear", "guaranteed". None of them can see a NEGATIVE claim that has
 * gone stale, and there are 23 of those across seven files: "Nothing will reach
 * you when this changes", "nothing in this platform sends an email or a WhatsApp
 * message today", "there is nothing that notifies you". Every one was true when
 * written. Every one becomes a lie the day a mailer ships, told to a client on
 * the screen they opened to find out what is happening.
 *
 * Worse, one of them is PINNED BY A TEST: CaseProgress.test.tsx asserts
 * NO_NOTIFICATION_NOTE is rendered on every status, so a mailer would not break
 * that test — it would lock the false sentence in and stay green.
 *
 * So the fact moves here, into one constant that copy is written against and
 * that a test can compare against evidence the API cannot hide. Add a channel
 * and every stale sentence fails loudly, naming itself.
 *
 * TO CHANGE IT: add the channel here ONLY in the same commit that makes the
 * sending real, and expect the copy guards to fail until the sentences they name
 * are narrowed. That failure is the feature.
 */
export const SENDING_CHANNELS = ["email"];
/** Whether the platform can put a message on this channel at all. */
export function platformSendsOn(channel) {
    return SENDING_CHANNELS.includes(channel);
}
/** True while the platform sends nothing at all, on any channel. */
export function platformSendsNothing() {
    return SENDING_CHANNELS.length === 0;
}
/**
 * Why we are processing, recorded per purpose. Separated because consent to be
 * notified is not consent to have documents retained, and a subject may withdraw
 * one without the other.
 */
export const CONSENT_PURPOSES = [
    /** Process the parcel + identity data needed to run the title search. */
    "case_processing",
    /** Notify the client that something happened, over the channels they chose. */
    "delivery_notification",
    /** Hold uploaded documents for the retention period. */
    "document_retention",
];
/**
 * `in_app` cannot be refused for `delivery_notification` and is not offered as a
 * choice: it is where the report is delivered, and a case with no way to reach
 * the client is not a case. Email and WhatsApp are genuinely optional, and
 * WhatsApp especially — it is a transfer to Meta's infrastructure, so it must be
 * a deliberate opt-in rather than a pre-ticked default (COMPLIANCE §4).
 */
export const OPTIONAL_NOTIFICATION_CHANNELS = ["email", "whatsapp"];
//# sourceMappingURL=consent.js.map